
import * as api from '../../../store/apiClient';

export const exportProducts = (venueId: string, reportName: string, callback: (success: boolean, error: string | null) => void) => {

    let query = `api/v1/product/${venueId}/export`;

    return api.downloadFile(query, `${reportName}.csv`, callback);
}
